<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý khách hàng</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('customer', 'edit')">
        <div class="box-top-list">
          <span class="p-m-0">Chỉnh sửa thông tin khách hàng</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
            <Button :disabled="submitForm" class="p-button-success btn-custom" :label="(modelData != null ? 'Lưu' : 'Tạo')" @click="saveData" />
          </span>
        </div>
        <div class="list-data">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="full_name">Tên khách hàng<span class="error">*</span></label>
                <InputText id="full_name" type="text" v-model="full_name" />
                <small v-if="validationErrors && validationErrors['full_name']"
                    class="p-invalid" >{{validationErrors['full_name']}}</small>
              </div>
            </div>
            
            <!-- <div class="p-field p-col-12 p-md-6 box-custom-form">
              <div class="p-col-8 item-custom-form">
                <label class="title-group-form">Địa chỉ</label>
               </div>
            </div> -->

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="province_id">Tỉnh/Thành phố</label>
                <v-select :filterable="false" placeholder="Chọn tỉnh/thành phố" v-model="province_id"  :options="provinces" :reduce="province => province.value"  label="label" @search="fetchOptionsProvince" @input="changeProvince">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
                <!--<Dropdown :filter="true" placeholder="Chọn tỉnh/thành phố"  @change="changeProvince"  inputId="province_id" v-model="province_id" :options="provinces" optionLabel="label"  optionValue="value" />
            -->  </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="phone_number">Số điện thoại <span class="error">*</span></label>
                <InputText id="phone_number" type="text" v-model="phone_number"/>
                <small v-if="validationErrors && validationErrors['phone_number']"
                    class="p-invalid" >{{validationErrors['phone_number']}}</small>
                <small v-if="phone_exists"
                class="p-invalid" >Số điện thoại trùng với tài khoản khác</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="district_id">Quận/Huyện</label>
                <v-select :filterable="false" placeholder="Chọn quận/huyện" v-model="district_id"  :options="districts" :reduce="districts => districts.value"  label="label" @search="fetchOptionsDistrict" @input="changeDistrict">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
                <!--<Dropdown  :filter="true" placeholder="Chọn quận/huyện" @change="changeDistrict" inputId="district_id" v-model="district_id" :options="districts" optionLabel="label"  optionValue="value" />-->
              </div>
            </div>
            
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="email">Email</label>
                <InputText  id="email" type="text" v-model="email"/>
                <small v-if="validationErrors && validationErrors['email']"
                    class="p-invalid" >{{validationErrors['email']}}</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="ward_id">Phường/Xã</label>
                <v-select :filterable="false" placeholder="Chọn phường/xã" v-model="ward_id"  :options="wards" :reduce="wards => wards.value"  label="label" @search="fetchOptionsWard" >
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
               <!-- <Dropdown  :filter="true" placeholder="Chọn phường/xã" inputId="ward_id" v-model="ward_id" :options="wards" optionLabel="label"  optionValue="value" />
             --> </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="birthday">Ngày sinh</label>
                <Calendar @input="changeInput" id="icon" v-model="birthday" :showIcon="true"/>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="address">Số nhà</label>
                <InputText  id="address" type="text" v-model="address"/>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="unit_id">Nhóm khách hàng <span class="error">*</span></label>
                <Dropdown  placeholder="Chọn nhóm khách hàng" inputId="customer_type" v-model="customer_type" :options="customerType" optionLabel="label"  optionValue="value" />
                <small v-if="validationErrors && validationErrors['customer_type']"
                    class="p-invalid" >{{validationErrors['customer_type']}}</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="status">Trạng thái hoạt động <span class="error">*</span></label>
                <Dropdown  inputId="status" v-model="status" :options="optionStatus" optionLabel="label"  optionValue="value" />
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <div class="box_change_role" @click="show_popup_change_role" >
                  <img class="img_change_role" :src="$dataCommon.IMAGE.ICON_CHANGE" />
                  <span class="title_change_role" >Đổi quyền nhân viên</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div >
          <!--<div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
         -->
          <p class="p_title_1" style="text-align: left">Bạn có đồng ý chuyển quyền truy cập của khách hàng này thành nhân viên không?</p>
          <p class="p_title_1" style="text-align: left;font-style: italic;"><span style="font-weight: 700;text-decoration: underline;">Lưu ý:</span> Sau khi đồng ý thì cần cập nhật thêm một số thông tin cần thiết cho tài khoản tại Quản lý người dùng.</p>
          <div class="box_btn">
            <div class="p-grid">
            <div class="p-col-6" style="text-align: right">
              <Button
                  @click="change_role_user"
                  style="width: 100px;"
                  iconPos="right"
                  class="btn-custom"
                  :label="'Đồng ý'"
                  type="button"
              > </Button><!--@click="redirect_ToHistory"-->
            </div>
            <div class="p-col-6" style="text-align: left">
              <Button
                  style="width: 100px;"
                  iconPos="right"
                  class="btn-custom p-button-danger"
                  :label="'Hủy'"
                  type="button"
                  @click="cancel_popup"
              > </Button>
            </div>
            </div>
          </div>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Xác nhận</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from "moment";
import DataServices from '@/core/DataServices'
export default {
  data() {
    return {
      modelData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'customer',
      full_name: '',
      phone_number: '',
      email: '',
      address: '',
      province_id: null,
      district_id: null,
      ward_id: null,
      provinces: [],
      provinces_all: [],
      districts: [],
      wards: [],
      validationErrors: {},
      phone_exists: false,
      customerType: [{value: 1, label: 'Cá nhân'}, {value: 2, label: "Doanh nghiệp"}],
      customer_type: 0,
      birthday: '',
      submitForm: false,
      optionStatus: [{value: 0, label: 'Ngưng hoạt động'}, {value: 1, label: 'Đang hoạt động'} ],
      status: 0,
      showConfirmDialog:false
    }
  },
  async mounted () {
    var list_provinces_all = await this.provincesData();
    this.provinces = list_provinces_all;
    this.provinces_all = list_provinces_all;
    this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      await this.getData(Number(this.$route.params.id));
    }
  },
  methods: {
    async cancel_popup(){
      this.showConfirmDialog = false;
    },
    async show_popup_change_role(){
      this.showConfirmDialog = true;
    },
    async change_role_user(){
      this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      if (!this.$myConstants.isEmpty(this.modelData.user_id)){
        var where = {
          id:  {_eq: this.modelData.user_id}
        };
        var user =await DataServices.getObjectData('users',where,{id: 'desc'});
        if (!this.$myConstants.isEmpty(user)){
            if (user.user_type == this.$dataCommon.USER.USER_TYPE.CUSTOMER){
              var params = {
                'user_type': this.$dataCommon.USER.USER_TYPE.STAFF,
                'modified_date': this.$myConstants.currentDate(),
              }
              await DataServices.updateData('users', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.modelData.user_id }}})});
              this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Đổi quyền nhân viên thành công', life: 3000 });
              this.$router.push({path: '/admin/users/function/'+this.modelData.user_id});
              this.$store.commit('setLoading', false);
              return false;
            }else {
              this.$store.commit('setLoading', false);
              this.$toast.add({
                severity: 'error',
                summary: 'Thông báo',
                detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
                life: 3000
              });
              return false;
            }
        }
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
          life: 3000
        });
        this.$store.commit('setLoading', false);
      }

    },
    async getData(id) {
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "fields": "id user_id full_name phone_number email customer_type birthday province_id district_id ward_id address status user{ status is_enabled }"});
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        var model = list[0];
        this.modelData = model;
        if(model.full_name != undefined) this.full_name = model.full_name;
        if(model.phone_number != undefined && model.phone_number != '') {
          var phone_convert = model.phone_number;
          this.phone_number = phone_convert.replace('+84', '0');
        }
        //this.status = this.modelData.status;
        this.status = (this.modelData.user.is_enabled == true) ? 1:0;
        if(model.email != undefined) this.email = model.email;
        if(model.address != undefined) this.address = model.address;
        if(model.customer_type != undefined) this.customer_type = model.customer_type;
        if(model.province_id != undefined) this.province_id= model.province_id;
        if(model.district_id != undefined) this.district_id= model.district_id;
        if(model.ward_id != undefined) this.ward_id= model.ward_id;
        if(model.birthday != undefined) this.birthday= moment(model.birthday).format('DD/MM/yyyy');
        this.districts = [];
        this.wards = [];
        if (this.modelData && this.modelData != null) {
          if (this.province_id > 0) this.districts=await this.districtsData(this.province_id);
          if (this.district_id > 0) this.wards = await this.wardsData(this.district_id);
        }
        
        this.componentKey++;
      }
    },
    changeInput($event) {
      var date = new Date($event);
      this.birthday = moment(date).format('DD/MM/YYYY');
    },
    backList() {
       this.$router.push({path: '/admin/customer'});
    },
    async fetchOptionsProvince (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.provinces =await this.provincesData(whereAttact);
      }else {
        this.provinces = this.provinces_all;
      }
    },
    async provincesData(whereAttach = null) {
      var list_provinces =[];
      var list =await this.$coreService.getAllProvince(whereAttach);
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          list_provinces.push({label: item.name, value: item.id});
        }
      }
      return list_provinces;
    },
    async changeProvince() {
      this.districts = [];
      this.wards = [];
      this.district_id = null;
      this.ward_id = null;
      this.districts =await this.districtsData(this.province_id);
    },
    async changeDistrict() {
      this.wards = [];
      this.ward_id =  null;
      this.wards  = await this.wardsData(this.district_id);
    },
    async fetchOptionsDistrict (search, loading) {
      //console.log("searchsearch:",search);
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.districts =await this.districtsData(this.province_id,whereAttact);
      }else {
        this.districts =await this.districtsData(this.province_id);
      }
    },
    async districtsData(provinceID,whereAttach = null) {
      var list =await this.$coreService.getDistrictByIdProvince(provinceID,whereAttach)
      var list_disctrict = [];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          list_disctrict.push({label: item.name, value: item.id});
          //this.districts.push({label: item.name, value: item.id});
        }
      }
      return list_disctrict;
    },
    async fetchOptionsWard (search, loading) {
      console.log("searchsearch:",search);
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.wards =await this.wardsData(this.district_id,whereAttact);
      }else {
        this.wards =await this.wardsData(this.district_id);
      }
    },
    async wardsData(districtID,whereAttach = null) {
     var list =await this.$coreService.getWardByIdDistrict(districtID,whereAttach);
     var list_ward = [];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          list_ward.push({label: item.name, value: item.id});
          //this.wards.push({label: item.name, value: item.id});
        }
      }
      return list_ward;
    },
    async checkPhoneNumber() {
      this.phone_number = this.phone_number.trim();
      if (this.phone_number !== "") {
        var phone_convert = this.phone_number;
        phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
        var where = {
          phone_number: {'_ilike': phone_convert},
          //status: {'_in': [1] },
        }
        if (this.modelData != null) where = Object.assign(where, {user_id: {'_neq': this.modelData.user_id}})
        var data = await DataServices.getList(this.modelName, {"fields": "id status user_id phone_number", "variables": JSON.stringify({where_key: where})});
        console.log("item_useritem_user:",data[Object.keys(data)])
        if (data[Object.keys(data)].length > 0){
          var list_user_check = data[Object.keys(data)];
          var item_user = list_user_check[0];
          console.log("item_useritem_user:",item_user)
          if (item_user){
            if (parseFloat(item_user.status) == 2){
              var user_id = (item_user.user_id)  ? item_user.user_id:0;
              var phone_number = (item_user.phone_number)  ? item_user.phone_number:'';
              await this.$coreService.updateCustomerDelete(user_id,phone_number);
              return false;
            }
          }
        }
        return data && data[Object.keys(data)].length > 0
      }
    },
    
    async validationData() {
      this.validationErrors = {};
      if (this.full_name == undefined || this.full_name == '') this.validationErrors['full_name'] = 'Nhập tên khách hàng';
      if (this.phone_number == '' || this.phone_number.length == 0){
        this.validationErrors['phone_number'] = 'Nhập số điện thoại';
      }else {
        if (!this.$myConstants.validatePhone(this.phone_number,10)){
          this.validationErrors['phone_number'] = 'Không đúng định dạng số điện thoại di động, vui lòng nhập lại.';
        }else {
          //this.phone_exists = await this.checkPhoneNumber();
          //console.log("this.checkPhoneNumber():",await this.checkPhoneNumber())
          if (await this.checkPhoneNumber()){
            this.validationErrors['phone_number'] = 'Số điện thoại trùng với tài khoản khác';
          }
        }
      }
      //if (this.phone_number != '' && (this.phone_number.length != 10 || isNaN(this.phone_number))) this.validationErrors['phone_number'] = 'Nhập số điện thoại không đúng định dạng';
      if(this.customer_type  == undefined || this.customer_type  == 0) this.validationErrors['customer_type'] = 'Chọn nhóm khách hàng';
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async saveData() {
      this.submitForm = true;
      await this.validationData();
      if (!this.phone_exists && Object.entries(this.validationErrors).length === 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var phone_convert = '';
        if (this.phone_number.length == 10) {
          phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
        }
        var full_name_convert = (!this.$myConstants.isEmpty(this.full_name)) ? this.$myConstants.capitalizeFirst(this.full_name):'';
        var params = {
          'full_name': full_name_convert,
          'phone_number': phone_convert,
          'email': this.email,
          'address': this.address,
          'customer_type': this.customer_type,
          'country_id': 1,
          'province_id': this.province_id,
          'district_id': this.district_id,
          'ward_id': this.ward_id,
        }
        if (this.birthday != '') {
          var dateNow = new Date();
          const [d, M, y] = this.birthday.match(/\d+/g);
          var changeDate = new Date(y, M-1, d, dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
          var birthdayDate = changeDate.toUTCString();
          params['birthday'] = birthdayDate;
        }
        if (this.modelData != null) {
          params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
          await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.modelData.id }}})});
          var oldValue = this.modelData;
          var newValue = oldValue;
          newValue['full_name'] = this.full_name;
          newValue['phone_number'] = this.phone_number;
          newValue['email'] = this.email;
          newValue['address'] = this.address;
          newValue['customer_type'] = this.customer_type;
          newValue['province_id'] = this.province_id;
          newValue['district_id'] = this.district_id;
          newValue['ward_id'] = this.ward_id;
          newValue['birthday'] = this.birthday;
          newValue['status'] = this.status;
          var is_enabled = (this.status == 1) ? true:false;
          var updateStatusUser = {
            is_enabled: is_enabled,
            phone_number: phone_convert,
            full_name : full_name_convert,
          }
          DataServices.updateData('users', {"variables": JSON.stringify({data_update: updateStatusUser, where_key: { id: {'_eq': this.modelData.user_id }}})});
          var paramsLog = {
            customer_profile_id: this.modelData.id,
            user_id: this.modelData.user_id,
            modifier_id: this.$store.getters.fullname.id,
            old_value: JSON.stringify(oldValue),
            new_value: JSON.stringify(newValue),
            created_date: this.$myConstants.currentDate(),
            modified_date: this.$myConstants.currentDate()
          }
          await DataServices.insertData('customer_log_changed', {"variables": JSON.stringify({objects: paramsLog})});
          
          // nếu ngừng hoạt động những tài khoản không cho đăng nhập
          if (this.status == 0){
            //update status token về  0
            var updateStatusToken = {
              status: 0
            }
            DataServices.updateData('user_token', {"variables": JSON.stringify({data_update: updateStatusToken, where_key: { user_id: {'_eq': this.modelData.user_id },status: {'_eq': 1 }}})});
          }
          this.$store.commit('setLoading', false);
          this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
          setTimeout(() => {
            this.$router.push({path: '/admin/customer'});
          }, 500);
        }
      } else this.submitForm = false;
    },
    changeNumberOfAccount($event) {
      if (this.number_count_accounts > Number($event)) {
        this.number_of_accounts = this.number_count_accounts;
      }
    }
  }
}
</script>
<style lang="scss">
.box-top-list{border: 1px solid #ccc; padding: 10px; 
  span{font-size: 25px; text-align: left; display: inline-block;}
  .right-button{float: right; 
    span{font-size: 14px;}
    .p-button{border-radius: 5px; min-width: 100px; 
      &.btn-custom{ margin-left: 10px;}
      span{text-align: center;}
    }
  }
}
.box-custom-form { display: flex; padding-top: 0; padding-bottom: 0;
  .item-custom-form{display: inline-flex; align-items: center; padding-top: 0; padding-bottom: 0;
    .title-group-form{font-weight: bold; margin: 0;}
  }
}
.box_change_role{
  height: 40px;background-color: #1c9bde;border-radius: 5px;display: flex; align-items: center;width: fit-content; padding: 8px;cursor: pointer;
  .img_change_role{
    margin-left: 8px;height: 28px;width: 20px;
  }
  .title_change_role{
    color: #FFFFFF;font-weight: 400;height: fit-content;margin-left: 8px;
  }
}
.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
</style>